import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_new_select = _resolveComponent("new-select")!
  const _component_new_input = _resolveComponent("new-input")!
  const _component_new_modal = _resolveComponent("new-modal")!

  return (_openBlock(), _createBlock(_component_new_modal, {
    title: "Добавление в лист ожидания",
    class: "medium",
    overflow: false,
    loading: _ctx.isLoading,
    onSubmit: _ctx.onSubmit,
    onCancel: _ctx.onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_new_select, {
        value: _ctx.state.statusCode,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.statusCode) = $event)),
        placeholder: "Выберите статус",
        options: _ctx.statuses_state.list,
        loading: _ctx.statuses_state.is_loading,
        failed: _ctx.statuses_state.is_failed,
        "error-text": "При получении списка статусов произошла ошибка",
        "search-without-refresh": "",
        "select-by": "code",
        disabled: _ctx.isLoading,
        "is-invalid": _ctx.validation$.statusCode.$error,
        "validation-errors": _ctx.validation$.statusCode.$errors,
        onRefresh: _ctx.loadStatuses,
        onChange: _ctx.onStatusChange
      }, null, 8, ["value", "options", "loading", "failed", "disabled", "is-invalid", "validation-errors", "onRefresh", "onChange"]),
      (_ctx.isDate)
        ? (_openBlock(), _createBlock(_component_new_input, {
            key: 0,
            class: "mt-4",
            value: _ctx.state.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.value) = $event)),
            placeholder: "Выберите новую дату",
            type: "date",
            "is-invalid": _ctx.validation$.value.$error,
            "validation-errors": _ctx.validation$.value.$errors,
            disabled: _ctx.isLoading
          }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]))
        : _createCommentVNode("", true),
      _createVNode(_component_new_select, {
        class: "mt-4",
        value: _ctx.state.comment,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.comment) = $event)),
        placeholder: "Комментарий",
        options: _ctx.comments_state.list,
        loading: _ctx.comments_state.is_loading,
        failed: _ctx.comments_state.is_failed,
        "error-text": "При получении списка произошла ошибка",
        "search-without-refresh": "",
        "select-by": "text",
        label: "text",
        disabled: _ctx.isLoading,
        onRefresh: _ctx.loadComments,
        onChange: _ctx.onCommentChange
      }, null, 8, ["value", "options", "loading", "failed", "disabled", "onRefresh", "onChange"]),
      (_ctx.state.is_other)
        ? (_openBlock(), _createBlock(_component_new_input, {
            key: 1,
            class: "mt-4",
            value: _ctx.state.comment_other,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.comment_other) = $event)),
            placeholder: "Напишите комментарий",
            disabled: _ctx.isLoading
          }, null, 8, ["value", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading", "onSubmit", "onCancel"]))
}